export default "__VITE_ASSET__yQxujQVi__"